import { Subject } from "rxjs";

import { UserSessionService } from "../../../../services/user-session/user-session.service";
import { WebservicesService } from "../../../../services/webservices/webservices.service";
import { ConfigService } from "../../../../services/config/config.service";
import { CustomerModel } from "../../../../models/customer-model";
import { InAppBrowserObject } from "@ionic-native/in-app-browser/ngx";
import {
  GameLaunchParams,
  VendorAdapterInterface,
} from "../vendor-adapter-interface";
import { ODRSwiftInterface, GameViewInterface, ODRController } from "../../../odr-controller";
import { PlatformResponse } from "src/app/interfaces/webservices-interface";

declare var ODR: ODRSwiftInterface;

export class EvolutionRedtigerOSSAdapter implements VendorAdapterInterface {
  protected windowRef: any;
  protected customer: CustomerModel;
  protected sessionToken: string;

  constructor(
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    private config: ConfigService,
    private telemetrySubject: Subject<any>
  ) {
    this.userSession.getCustomer().subscribe((customer) => {
      this.customer = customer;
      this.sessionToken = this.userSession.getSessionToken();
    });
  }

  public setWindowRef(windowRef: InAppBrowserObject | GameViewInterface): void {
    this.windowRef = windowRef as InAppBrowserObject;
  }

  public getWindowRef(): InAppBrowserObject | GameViewInterface {
    return this.windowRef;
  }

  public odrSessionId(): Subject<any> {
    return this.telemetrySubject;
  }

  public windowStrategy() {
    return "inappbrowser";
  }

  public shouldDescendIntoDirs() {
    return false;
  }

  public getTagLayout(extGameParams: GameLaunchParams): Promise<Array<any>> {
    return this.config.isLoaded().then( () => {
      let jurisdiction = ODRController.clientAppJurisdiction(this.config.getClientApp());
      let coretag = `redtiger-common`;
      let tag = `evolution-${jurisdiction}-${extGameParams.extGameType}`;
      console.log("ODR: tag == "+tag);
      var tagMappingList = [];
      if( coretag) {
        tagMappingList.push( {
          loc: "/", tag: coretag
        })
      }
      if( tag) {
        tagMappingList.push( {
          loc: "/", tag: tag
        })
      }

      return tagMappingList;
    });
  }

  public credentials(p: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.webservices
        .get("games/launch-casino", {
          customer_id: p.customer_id ? p.customer_id : null,
          session_token: p.session_token ? p.session_token : null,
          vendor: p.ODR.vendor,
          clientapp: this.config.getClientApp(),
          game_launcher_id: p.gameLaunchId,
          is_mobile: true,
          noredirect: true,
        })
        .subscribe(
          (resp: PlatformResponse<any>) => {
            if ("undefined" !== typeof resp.payload.href) {
//              resp.payload.href = resp.payload.href.replace( 'launchgame.html', 'index.html');
              this.telemetrySubject.next( resp.payload.href);
              resolve(Object.assign(p, resp.payload));
            } else {
              console.log(
                "ODR: generic.ts: games/get-vendor-credentials: gamerequest failed:",
                resp
              );
              reject(resp);
            }
          },
          (err: any) => {
            console.log(
              "ODR: generic.ts: games/get-vendor-credentials error: ",
              err
            );
            reject(err);
          }
        );
    });
  }

  public launchODR(
    windowRef: InAppBrowserObject,
    gamePrms: any
  ): InAppBrowserObject {
    this.windowRef = windowRef;

    var paramObj = {
      origin: gamePrms.href,
    };
    var params = Object.keys(paramObj)
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(paramObj[k])}`)
      .join("&");

    var url: string = `http://localhost:9090/core/index.html?${params}`;
    
    windowRef.executeScript({
      code: `
            window.location.href = '${url}'
            `,
    });
    return windowRef;
  }

  public evaluateJavascript(js: string): Promise<any> {
    if (this.windowRef) {
      return this.windowRef.executeScript({
        code: js,
      });
    } else {
      return Promise.reject("ODR: generic.ts: invalid windowRef");
    }
  }

  public onGameClosed(windowRef: InAppBrowserObject, closedCb: () => void) {
    var ticket: number = 1; // prevent closeCb from being called by multiple close events

    let intervalID = setInterval(() => {
      windowRef
        .executeScript({ code: "window._game_has_closed" })
        .then((val) => {
          if (val[0]) {
            clearInterval(intervalID);
            if (!--ticket) {
              console.log("ODR: generic.ts: onGameClosed: _game_has_closed");
              windowRef.close();
              closedCb();
            } else {
              ticket++;
            }
          }
        });
    }, 500);
    windowRef.on("exit").subscribe((event) => {
      if (!--ticket) {
        console.log("ODR: generic.ts: onGameClosed");
        closedCb();
      } else {
        ticket++;
      }
    });
  }
}
